// utils/languageDetector.js
const getBrowserLanguage = () => {
  const browserLanguage = navigator.language || navigator.userLanguage;
  console.log("Detected browser language:", browserLanguage);

  if (browserLanguage.startsWith("hi")) return "hi"; // Hindi
  if (browserLanguage.startsWith("mr")) return "mr"; // Marathi
  if (browserLanguage.startsWith("gu")) return "gu"; // Gujarati
  if (browserLanguage.startsWith("kn")) return "kn"; // Kannada
  if (browserLanguage.startsWith("ta")) return "ta"; // Tamil
  return "en"; // Default to English
};

export default getBrowserLanguage;